const compactMetadata = (metadata) =>
    Object.entries(metadata).reduce((result, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            result[key] = String(value)
        }
        return result
    }, {})

export const logDocumentTemplateEvent = (
    client,
    eventName,
    { template, source, value, metadata = {} } = {}
) => {
    if (!client?.logEvent) return

    const itemCount = template?.itemCount ?? template?.items?.length
    const eventMetadata = compactMetadata({
        source,
        template_id: template?.id,
        owner_type: template?.ownerType,
        loan_type: template?.loanTypes?.join(','),
        purpose: template?.purpose,
        income_type: template?.incomeTypes?.join(','),
        license_states: template?.allStates
            ? 'All'
            : template?.licenseStates?.join(','),
        is_default: template?.isDefault,
        item_count: itemCount,
        ...metadata,
    })

    void client.logEvent(
        eventName,
        value ?? template?.id ?? source ?? 0,
        eventMetadata
    )
}
